import React from 'react';
import BadgeBase from './BadgeBase';
import TEBadgeSignal from '../../types/TEBadgeSignal';

const Dot = (props) => <BadgeBase {...props} signal={TEBadgeSignal.Dot} />;

export default Dot;
